// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_G5v","cls2":"VideoPlayerMainContent-cls2_9_l VideoPlayerMainContent-cls1_G5v"};